import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { superAuth } from "../services";
import { Skeleton } from "./ui";

// กันหน้า /su — ถาม Backend ทุกครั้งที่เข้า (ไม่เชื่อ user_type ใน localStorage)
export default function RequireSuperUser({ children }) {
  const location = useLocation();
  const [state, setState] = useState("checking");

  useEffect(() => {
    let alive = true;
    superAuth
      .verify()
      .then((ok) => alive && setState(ok ? "ok" : "denied"))
      .catch(() => alive && setState("denied"));
    return () => {
      alive = false;
    };
  }, []);

  if (state === "checking") return <Skeleton height={240} style={{ margin: 24 }} />;
  if (state === "denied") return <Navigate to="/su/login" replace state={{ from: location.pathname }} />;
  return children;
}
